import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/gift-cards/giftCard.png")